import HallwayExperience from "@inter-ikea-range/hallway-experience";

import type { EnvironmentSettings, Experience } from "@inter-ikea-space-platform/experience";

// room experience
export const hallwayExperience = (settings: EnvironmentSettings) => HallwayExperience(settings);

// range packages
export const hallwayPackages = (_settings: EnvironmentSettings): Experience[] => [];
